/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './InsuranceContentTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useAppSelector } from '../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import { check_user_permission } from '../../configs/utils';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  insuranceName: string;
  policyNumber: number;
  startDate: string;
  expireDate: string;
  onClick?: any;
  policyType: string;
  amount: any;
  isEdit?: boolean;
  onEdit?: any;
}
const InsuranceContentTile: React.FC<contentTileType> = ({
  startDate,
  insuranceName,
  policyNumber,
  expireDate,
  onClick,
  amount,
  policyType,
  isEdit = false,
  onEdit,
}) => {
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);
  const { t } = useTranslation();
  const trans = t;

  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  return (
    <Grid container className="claim-history-container">
      <Grid item xs={9}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {insuranceName}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '10px',
            }}
          >
            {trans('Policy No')}{': '}
            <span style={{ color: themes.blackDefault, padding: '0 5px' }}>
              {policyNumber}
            </span>{' '}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
            }}
          >
            {trans('Policy Type')}:{' '}
            <span style={{ color: themes.blackDefault, padding: '0 5px' }}>
              {policyType}
            </span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Start Date')}:{' '}
            <span style={{ color: themes.blackDefault, padding: '0 5px' }}>
              <DateField value={startDate} format={baseDateFormatting} />
            </span>{' '}
            |
            <span style={{ color: themes.defaultError, padding: '0 5px' }}>
              {' '}
              {trans('Expiry Date')}:{' '}
              <DateField value={expireDate} format={baseDateFormatting} />
            </span>{' '}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
            }}
          >
            {trans('Amount')}:{' '}
            <span
              style={{
                color: themes.blackDefault,
                padding: '0 5px',
              }}
            >
              {amount}
            </span>{' '}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        {check_user_permission(auth_permissions, hr_view, 'edit') && (
          <div>
            {isEdit && (
              <Box className="icon-box_leave_history" onClick={onEdit}>
                {' '}
                <i
                  className="las la-pencil-alt"
                  style={{ color: themes.primaryMain }}
                />{' '}
              </Box>
            )}
          </div>
        )}
      </Grid>

      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Box className="icon-box_leave_history" onClick={onClick}>
          {' '}
          <i
            className="las la-eye"
            style={{ color: themes.primaryMain }}
          />{' '}
        </Box>
      </Grid>
    </Grid>
  );
};

export default InsuranceContentTile;
